import { useSelector } from 'react-redux';
import * as types from '../types';

export default function useIsPayPalEnabled() {
  return useSelector((state: types.AppState) => state.config.siteConfig.allowPaypalCredit);
}
